module.exports = __webpack_public_path__ + "img/logo-appStore.f8e7d671.png";